"use client";

import { graphql, readFragment } from "@opensea/graphql";
import { useNumberFormatter } from "@opensea/i18n";
import { useIsHydrated } from "@opensea/ui-kit/hooks";
export const useCollectionTitleFragment = graphql(`
  fragment useCollectionTitle on CollectionResult {
    ... on Collection {
      name
      floorPrice {
        pricePerItem {
          token {
            unit
            symbol
          }
        }
      }
    }
    __typename
  }
`);
export function useCollectionTitle(collectionKey) {
  const collection = readFragment(useCollectionTitleFragment, collectionKey);
  const format = useNumberFormatter();
  const isHydrated = useIsHydrated();
  function getTitle() {
    if (!collection || collection.__typename !== "Collection") {
      return null;
    }

    // We check hydrated because we want to avoid showing the price in SEO
    if (!(collection.floorPrice?.pricePerItem && isHydrated)) {
      return `${collection.name} - Collection | OpenSea`;
    }
    return `${collection.name} ${format(collection.floorPrice.pricePerItem.token.unit, {
      suffix: collection.floorPrice.pricePerItem.token.symbol
    })} - Collection | OpenSea`;
  }
  return getTitle();
}